import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router';
import { ErrorScreen } from '@/components/ErrorScreen/ErrorScreen';
import { ConfigProvider } from '@/providers/ConfigProvider/ConfigProvider';
import { DeviceProvider } from '@/providers/DeviceProvider/DeviceProvider';
import { PresentationProvider } from '@/providers/PresentationProvider/PresentationProvider';
import { TransactionProvider } from '@/providers/TransactionProvider/TransactionProvider';
import { cn } from '@/utils/cn';
import { DeviceCompatibilityWrapper } from '@/wrappers/DeviceCompatibilityWrapper/DeviceCompatibilityWrapper';
import { ThemeWrapper } from '@/wrappers/ThemeWrapper/ThemeWrapper';
import { AppRoot } from '@cof/omni-react';

export function AirKeyWrapper() {
  return (
    // add we hit a snag as generic error
    <ErrorBoundary FallbackComponent={ErrorScreen}>
      <AppRoot className={cn('bg-page')}>
        <PresentationProvider>
          <ConfigProvider>
            <ThemeWrapper>
              <DeviceProvider>
                <DeviceCompatibilityWrapper>
                  <TransactionProvider>
                    <Outlet />
                  </TransactionProvider>
                </DeviceCompatibilityWrapper>
              </DeviceProvider>
            </ThemeWrapper>
          </ConfigProvider>
        </PresentationProvider>
      </AppRoot>
    </ErrorBoundary>
  );
}
